import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import NGTVariableManager from "../../../ngt/base/NGTVariableManager";
import DashboardEvent from "../event/DashboardEvent";

export default class DashboardOpenerMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, languagePack) {
        super(target, dispatcher);

        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();

        this._handleButtonBound = this._handleButton.bind(this);
        this._button = this.createButton(this._target, this._handleButtonBound);
        this._button.setEnabled(false);
        this._target.alpha = 0;

        this.registerEventListener(DashboardEvent.ENABLE_DASHBOARD_BUTTON, this._handleEnableDashboardButton.bind(this));
        this.registerEventListener(DashboardEvent.DISABLE_DASHBOARD_BUTTON, this._handleDisableDashboardButton.bind(this));
    }

    _showNewIndicator() {
        this._target.newIndicator.alpha = 1;
    }

    _hideNewIndicator() {
        this._target.newIndicator.alpha = 0;
    }

    _handleButton() {
        this._hideNewIndicator();
        this.dispatch(DashboardEvent.OPEN_SCREEN_REQUEST);
    }

    _handleEnableDashboardButton(evt) {
        this._button.setEnabled(true);
        createjs.Tween.get(this._target).to({ alpha: 1 }, 350, createjs.Ease.sineOut);
    }

    _handleDisableDashboardButton(evt) {
        this._button.setEnabled(false);
        this._target.alpha = 0;
    }
}